const ACTIVE_CLASS = "active";
const HOVER_CLASS = "hover";

function init($views) {
	$views.forEach(($view) => {
		if ("ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
			$view.addEventListener("click", () => $view.classList.toggle(ACTIVE_CLASS));
		} else {
			$view.classList.add(HOVER_CLASS);
		}
	});
}

export default {
	view: "flip-card",
	init,
};
